import React from "react";
import PropTypes from "prop-types";
import styles from "./PinLevelPermissionCheckboxList.module.css";
import PinLevelPermissionCheckbox from "../PinLevelPermissionCheckbox";

/**
 * View component. A list of checkbox items that allows the user to toggle pin level permissions for a feed item.
 */
export function PinLevelPermissionCheckboxList({
  checkedPermissions = [], // Add safeguard for 'undefined'
  setCheckedPermissions,
}) {
  // Map UI-friendly Labels
  const permissionMap = {
    AssociateIbo: "IBO",
    Platinum: "PLA",
    Emerald: "EM",
    Diamond: "DIA",
  };

  const permissionLevels = ["AssociateIbo", "Platinum", "Emerald", "Diamond"];

  return (
    <div className={styles.container}>
      <h5 className={styles.label}>Pin Level Permissions</h5>

      <div className={styles.permission}>
        {permissionLevels.map((permissionLevel, index) => (
          <div key={index}>
            <PinLevelPermissionCheckbox
              pinLevelType={permissionMap[permissionLevel]} // Update to use new permissionMap (e.g., "PLA")
              label={permissionLevel} // e.g., "Platinum"
              isChecked={checkedPermissions.includes(permissionLevel)}
              setCheckedPermissions={setCheckedPermissions}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

PinLevelPermissionCheckboxList.propTypes = {
  /**
   * An array of the currently checked pin level permission values. .
   */
  checkedPermissions: PropTypes.arrayOf(PropTypes.string),
  /**
   * Function that alters the state value of checkedPermissions when a checkbox item is toggled.
   */
  setCheckedPermissions: PropTypes.func,
};
